import {
  createFacialControllerAsync,
  deleteFacialControllerAsync,
  getAllControllersForSelectionAsync,
  getAllFacialControllerByLicenseAsync,
  getFacialControllerByIdAsync,
  updateConfigFacialControllerAsync,
  updateFacialControllerAsync,
} from '../../index';
import { useMutation } from 'react-query';

export const useCreateFacialControllerAsync = () =>
  useMutation(createFacialControllerAsync);

export const useGetFacialControllerByIdAsync = () =>
  useMutation(getFacialControllerByIdAsync);

export const useGetAllFacialControllerByLicenseAsync = () =>
  useMutation(getAllFacialControllerByLicenseAsync);

export const useUpdateFacialControllerAsync = () =>
  useMutation(updateFacialControllerAsync);

export const useUpdateConfigFacialControllerAsync = () =>
  useMutation(updateConfigFacialControllerAsync);

export const useDeleteFacialControllerAsync = () =>
  useMutation(deleteFacialControllerAsync);

export const useGetAllControllersForSelectionMutateAsync = () => {
  return useMutation(getAllControllersForSelectionAsync);
};
